The end date of the posting.

Scheme requirements:

- For the `seekAnz` scheme this must be no more than 30 days after the job ad was initially posted.

  If an end date is omitted, the job ad's existing end date will be preserved.
